export const HOLD_MS = 2200;
export const FADE_MS = 320;
